import Vue from 'vue';
import Router from 'vue-router';
import { getUrlParameter, removeURLParameter, notEmpty, empty, matchGameDetail, LanguageSupportedList, DefaultLanguage, KoreanPages, matchLogin, } from '../constant';
import store from '../store';
import { navigateToQuestion, getToken, setGameId, setToken, setTestId, setOpenId } from '../util/auth';
import { getParentGameId, getParentOpenId, getParentTestId, getChannel } from '../util/auth';
import { changeTabIconAndName } from '../util/changeTab';
import { setCookiesBanner } from '../util/APIUtils.js';
import { validURL } from "../globalFunc";

import common from './sub/common';
import cloudgame from './sub/cloudgame';
import webview4app from './sub/webview4app';

import Cookies from 'js-cookie';

import i18n, { loadLanguageAsync } from "../i18n";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const lastGameId = window.localStorage.getItem('last_game_id');

const router = new Router({
  mode: 'history',

  routes: [
    {
      path: '',
      component: () => import('@/components/layout/RootLayout.vue'),
      redirect: `/cloudGame/${lastGameId}`,
      children: [
        // sub
        ...common,
        ...cloudgame,
        ...webview4app,
      ],
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});




router.beforeEach(async (to, from, next) => {
  console.log('vue-router beforeEach');

  //存储channel
  let channel = getChannel();

  // 替换tab的icon和名称
  changeTabIconAndName();


  // 优先选择cookies语言（手动切换）其次选择浏览器语言
  let lang = notEmpty(Cookies.get('language')) ? Cookies.get('language') : navigator.language;
  // 如果主站语言中包含所切换得语言，那么主站语言为切换对应语言否则为兜底语言（en）
  // [hard code] 若是game8链接，默认设为日语
  if (window.location.href.indexOf("545007") != -1 || window.location.href.indexOf("2l56r5") != -1) {
    Cookies.set("language", "ja", {
      path: window.location.pathname,
    });
    lang = 'ja';
  } else {
    if (window.location.href.indexOf("8bd999") > 0) {
      lang = 'ko';
    } else {
      if (LanguageSupportedList.indexOf(lang) !== -1) {
        store.dispatch('setLanguage', lang);
        // Cookies.set('language', lang);
        i18n.locale = lang;
      } else {
        // 站点不支持浏览器语言 显示默认语言
        store.dispatch('setLanguage', DefaultLanguage);
        // Cookies.set('language', DefaultLanguage);
        i18n.locale = DefaultLanguage;
        lang = DefaultLanguage;
      }
    }
  }
  await loadLanguageAsync(lang);

  if (to.meta.title) document.title = to.meta.title;

  document.title = document.title ? document.title : 'Cloud Gaming';

  const hasToken = getToken();
  let error = getUrlParameter(window.location.search, 'error');
  // 判断url中是否有token
  let signupToken = getUrlParameter(window.location.search, 'paramsDavasvssegrgre');
  let loginToken = getUrlParameter(window.location.search, 'loginToken');
  let resetPwdtoken = getUrlParameter(window.location.search, 'resetPwdtoken');
  let urlToken = notEmpty(signupToken) || notEmpty(loginToken) || notEmpty(resetPwdtoken);
  console.log(getUrlParameter(window.location.search, 'sTaskId'), getUrlParameter(window.location.search, 'type'));
  //问卷登录跳转逻辑
  if (to.name === 'login') {
    Cookies.set('sTaskId', getUrlParameter(window.location.search, 'sTaskId'));
    Cookies.set('type', getUrlParameter(window.location.search, 'type'));
  }

  if (error) {
    console.log('error', error);
    window.location.href = '/'; // 避免死循环
  } else {
    if (hasToken || urlToken) {
      if (hasToken) {
        if (to.name === 'login') {
          //判断是否跳转问卷
          if (Cookies.get('sTaskId') && Cookies.get('type')) {
            navigateToQuestion();
          }
          // if is logged in, redirect to the home page
          setToken(getToken());
          let redirect = getUrlParameter(window.location.search, 'redirect');
          if (empty(redirect)) {
            next({ path: '/' });
          } else {
            let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
            if (Expression.test(redirect)) {
              if (validURL(redirect)) {
                window.location = redirect;
              } else {
                next({ path: '/' });
              }
            } else {
              next({ path: redirect || '/' });
            }
          }

        } else {
          // if(empty(store.getters.email) && empty(store.getters.name)){
          //   store.dispatch('getInfo').then(response => { // 拉取user_info
          //     // console.log(response);
          //     next();
          //   }).catch(() => {
          //     // remove token and go to login page to re-login
          //     store.dispatch('resetToken').then(() => {
          //       next(`/login?redirect=${to.path}`);
          //     });
          //   });
          // }
          // else {
          next();
          // }
        }
      }
      else if (!hasToken && urlToken) {
        let newUrl = to.fullPath;
        //console.log("newUrl", newUrl);
        if (to.name !== 'signup' && to.name !== 'recoverPwdForm' && to.name !== 'aftersendmail') {
          if (notEmpty(loginToken)) {
            setToken('Bearer ' + loginToken);
          }
          if (signupToken)
            newUrl = removeURLParameter(newUrl, 'paramsDavasvssegrgre');
          if (loginToken) {
            console.log('198');
            newUrl = removeURLParameter(newUrl, 'loginToken');

            if (resetPwdtoken)
              newUrl = removeURLParameter(newUrl, 'resetPwdtoken');
            //如果不需要跳回问卷，则走正常跳转逻辑
            if (!(Cookies.get('sTaskId') && Cookies.get('type'))) {
              window.location.href = newUrl;
            }
            else {
              navigateToQuestion();
            }
          }

          // console.log(206);
        } else {
          next();
        }
      } else {
        next();
      }
    }
    else {
      if (to.matched.some(m => m.meta.requireAuth)) {
        next({ name: 'login' });
      } else {
        next();
      }
    }
  }
  let lastPageName = window.sessionStorage.getItem('lastPageName');
  // 初次进入网站未设置cookies偏好刷新页面
  store.dispatch('getFingerId').then(async () => {
    let firstLook = window.localStorage.getItem('firstLook');
    if (firstLook === 'true' && to.name !== 'cookiePolicy' && from.name !== 'cookiePolicy' && lastPageName !== 'cookiePolicy') {
      let params = {
        finger: store.getters.fingerId,
        optionType: 1,
      };
      let res = await setCookiesBanner(params);
      if (res.code === 0) {
        window.localStorage.setItem('gaDisable', true);
        window.localStorage.setItem('firstLook', false);
      }
    }
  });
  window.sessionStorage.setItem('lastPageName', to.name);
  window.onerror = function (message, url, line, column, error) {
    window.sessionStorage.setItem('windowerror', message);
    console.log("message", message, "url", url, "line", line, "column", column, "error", error);
  };
});



export default router;
